import * as R from 'ramda';
import {
  generMutation,
} from '@/utils';
import { login as api } from '@/api';

const state = {
  userInfo: {},
};

const actions = {
  async getUserInfo({ commit, dispatch }) {
    const res = await api.getUserInfo();
    if (R.is(Object, res)) {
      commit('setUserInfo', res);
      dispatch('rbac/getRbacList', {}, { root: true });
      return res;
    }
    commit('setUserInfo', {});
    return null;
  },
};

const getters = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: generMutation(R.keys(state)),
};



// WEBPACK FOOTER //
// ./src/store/common/index.js